/* eslint-disable @typescript-eslint/no-explicit-any */
/* eslint-disable @typescript-eslint/no-unsafe-call */
import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

const CUSTOMER_ID = '15092';
const SCRIPT_ID = 'rs_req_Init';
const serverURL = `https://cdn-eu.readspeaker.com/script/${CUSTOMER_ID}/webReader/webReader.js?pids=wr`;

declare global {
  interface Window {
    rspkr?: any;
    rsConf?: {
      extraMods?: {};
      general: {
        usePost: boolean;
        shadowDomSelector?: string;
        nativeLanguages?: boolean;
        uiLang?: string;
        customTransLangs?: string;
      };
      ui?: {
        tools?: {
          translation?: boolean;
          formreading?: boolean;
          clicklisten?: boolean;
          textmode?: boolean;
          controlpanel?: boolean;
        };
        controlpanel?: {
          horizontal?: string;
          vertical?: string;
        };
      };
    };
  }
}

export const languageToReadSpeakerLang = (lang: string): string => {
  switch (lang.toLowerCase()) {
    case 'nl':
      return 'nl_nl';
    case 'en':
      return 'en';
    case 'de':
      return 'de_de';
    default:
      return 'en';
  }
};

const loadReadSpeaker = () => {
  if (document.getElementById(SCRIPT_ID)) return;

  window.rsConf = {
    extraMods: {},
    general: {
      usePost: true,
      shadowDomSelector: '.hydrated',
      nativeLanguages: true,
      customTransLangs: 'de_de, en, nl_nl',
      uiLang: 'nl_nl',
    },
    ui: {
      tools: {
        translation: true,
        formreading: false,
        clicklisten: false,
        textmode: false,
        controlpanel: true,
      },
      controlpanel: {
        horizontal: 'left',
      },
    },
  };

  const script = document.createElement('script');
  script.id = SCRIPT_ID;
  script.type = 'text/javascript';
  script.src = serverURL;
  script.async = true;
  document.head.appendChild(script);
};

export const reInitReadSpeaker = () => {
  if (window.rspkr && window.rspkr.ui) {
    window.rspkr.ui.destroyActivePlayer();
    window.rspkr.init();
  }
};

export const changeLanguageReadSpeaker = (lang: string) => {
  if (window.rspkr && window.rspkr.ui) {
    window.rspkr.Lang.setUiLang(languageToReadSpeakerLang(lang), {
      load: true,
      updateUi: true,
    });
  }
};

export const ReadSpeakerProvider = () => {
  const location = useLocation();

  useEffect(() => {
    loadReadSpeaker();
  }, []);

  useEffect(() => {
    const timeout = setTimeout(() => {
      reInitReadSpeaker();
    }, 500);

    return () => clearTimeout(timeout);
  }, [location.pathname]);

  return null;
};
